export default __webpack_public_path__ + "locales/ja-JP/FormGallery.json?hash=a2fc7adba4b4fbb78183cd4870c067bd";